// extracted by mini-css-extract-plugin
export default {"card":"AddCard_card__prUZx","iconContainer":"AddCard_iconContainer__WOmuy","label":"AddCard_label__4d2hf","content":"AddCard_content__r2qkM"};